

jQuery(document).ready(function($) {
	var resetNavigation = function() {
    var viewportwidth = document.body.clientWidth;
	
    if (viewportwidth < 1000) {    
		$("body").addClass("m-view").removeClass("d-view");
		$(".main-navigation-ul").addClass("opening");
		$(".menu-toggle").addClass("open");
		$("header").addClass("m-menu-parent").removeClass("d-menu-parent");
		$("#d-menu").fadeOut(0);
		$("#m-menu").fadeIn(0);
    } else {
		$("body").addClass("d-view").removeClass("m-view");
		$(".main-navigation-ul").removeClass("opening");
		$(".menu-toggle").removeClass("open");
		$("header").addClass("d-menu-parent").removeClass("m-menu-parent");
		$("#m-menu").fadeOut(0);
		$("#d-menu").fadeIn(0);
    };
  };
  
  var setUpNavigation = function() {
		//console.log("setUpNavigation");
	   if($("body").hasClass("d-view")){
		   //DESKTOP
		   //open/close mega-navigation
			$(".cd-dropdown-trigger").unbind();
			$('.desktop-view .cd-dropdown-trigger').on('mouseover', function(event){
				event.preventDefault();
				toggleNav($(this).attr("data-target"), this);
			});
			
			$(".desktop-view .main-navigation-ul > li > .cd-dropdown > .cd-dropdown-content").mouseleave(function(){ 
				//console.log("DESKTOP MOUSE LEAVE");
				hideNav();
			});
			
	   }else if($("body").hasClass("m-view")){
		   //MOBILE
		   $(".cd-dropdown-trigger").unbind();
			$('.mobile-view .cd-dropdown-trigger').on('click', function(event){
				event.preventDefault();
				toggleNav($(this).attr("data-target"), this);
			});
	   }
	   
	   
		
		
  };
  
  var hideNav = function(){
	  //console.log("hideNav");
		$('#d-menu .cd-dropdown').removeClass('dropdown-is-active');
		$('#d-menu .cd-dropdown-trigger').removeClass('dropdown-is-active');
  };
  
  var toggleNav = function($navTarget, $this){
	 // console.log("toggleNav");
	  var navIsVisible = ( !$($this).next('#'+$navTarget).hasClass('dropdown-is-active') ) ? true : false;
		//console.log(navIsVisible);
		$('.cd-dropdown').removeClass('dropdown-is-active');
		$('.cd-dropdown-trigger').removeClass('dropdown-is-active');
		$($this).next('#'+$navTarget).toggleClass('dropdown-is-active', navIsVisible);
		$($this).toggleClass('dropdown-is-active', navIsVisible);
		if( !navIsVisible ) {
			$($this).next('#'+$navTarget).one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',function(){
				$('.has-children ul').addClass('is-hidden');
				$('.move-out').removeClass('move-out');
				$('.is-active').removeClass('is-active');
			});	
		}
  };
  
  var initialMenu = function(){
	  	if($("body").hasClass("d-view")){
			//console.log("BODY DESKTOP");
			//on desktop - differentiate between a user trying to hover over a dropdown item vs trying to navigate into a submenu's contents
			var submenuDirection = ( !$('.cd-dropdown-wrapper').hasClass('open-to-left') ) ? 'right' : 'left';
			$('.d-view .cd-dropdown-content').menuAim({
				activate: function(row) {
					$(row).children().addClass('is-active').removeClass('fade-out');
					if( $('.cd-dropdown-content .fade-in').length == 0 ) $(row).children('ul').addClass('fade-in');
				},
				deactivate: function(row) {
					$(row).children().removeClass('is-active');
					if( $('li.has-children:hover').length == 0 || $('li.has-children:hover').is($(row)) ) {
						$('.cd-dropdown-content').find('.fade-in').removeClass('fade-in');
						$(row).children('ul').addClass('fade-out')
					}
				},
				exitMenu: function() {
					$('.cd-dropdown-content').find('.is-active').removeClass('is-active');
					return true;
				},
				submenuDirection: submenuDirection,
			});
	}else if($("body").hasClass("m-view")){
			//console.log("BODY MOBILE");
			 $(".cd-dropdown .cd-close, .m-menu-parent .has-children, .go-back").unbind();
			//close meganavigation
				$('.cd-dropdown .cd-close').on('click', function(event){
					//console.log("Close");
					event.preventDefault();
					toggleNav();
				});

				//on mobile - open submenu
				$('.m-menu-parent .has-children').children('a').on('click', function(event){
					//prevent default clicking on direct children of .has-children 
					event.preventDefault();
					var selected = $(this);
					selected.next('ul').removeClass('is-hidden').end().parent('.has-children').parent('ul').addClass('move-out');
				});
				

				//submenu items - go back link
				$('.go-back').on('click', function(){
					var selected = $(this),
						visibleNav = $(this).parent('ul').parent('.has-children').parent('ul');
					selected.parent('ul').addClass('is-hidden').parent('.has-children').parent('ul').removeClass('move-out');
				}); 
				
				
	}
  }
  
  	
	 //Fire it when the page first loads:
  resetNavigation();
  setUpNavigation();
  initialMenu();
  
  $(window).resize(function(){
    resetNavigation();
	setUpNavigation();
	initialMenu();
  });
 
  
	var mouse_is_inside = false;
	$(".main-navigation-container").hover(function(){ 
        mouse_is_inside=true; 
    }, function(){ 
        mouse_is_inside=false; 
    });
	
	$("body").mouseup(function(){ 
        if(! mouse_is_inside){
			//hideNav();
			//console.log("MOUSE UP " + mouse_is_inside);
		}
    });
	
	$('.m-menu-parent .menu-toggle').click(function() {
		  $('.main-navigation-ul').toggleClass('opening');
		  $(this).toggleClass('open');

	});
	
	
	
	
	

	

	
	
	
	
	
	
	//IE9 placeholder fallback
	//credits http://www.hagenburger.net/BLOG/HTML5-Input-Placeholder-Fix-With-jQuery.html
	if(!Modernizr.input.placeholder){
		$('[placeholder]').focus(function() {
			var input = $(this);
			if (input.val() == input.attr('placeholder')) {
				input.val('');
		  	}
		}).blur(function() {
		 	var input = $(this);
		  	if (input.val() == '' || input.val() == input.attr('placeholder')) {
				input.val(input.attr('placeholder'));
		  	}
		}).blur();
		$('[placeholder]').parents('form').submit(function() {
		  	$(this).find('[placeholder]').each(function() {
				var input = $(this);
				if (input.val() == input.attr('placeholder')) {
			 		input.val('');
				}
		  	})
		});
	}
	
	

});